import { RawTimeZone, rawTimeZones } from '@vvo/tzdb';

export const formatByMask = (data: number | string, mask: string) => {
  if (!data) return;
  const text = String(data);
  const countMaskSymbols = mask.replaceAll('#', '').length;
  const outIteration = Array.from({ length: countMaskSymbols + text.length });
  let [setIndex, textOut] = [0, ''];

  outIteration.forEach((_, index) => {
    const maskSymbol = mask[index] || '';

    if (maskSymbol === '#') {
      textOut += text[setIndex] || '';
      setIndex += 1;
    } else {
      if (!maskSymbol) setIndex += 1;

      textOut += maskSymbol || text[setIndex] || '';
    }
  });

  return textOut;
};

export const displayAddress = (
  address: {
    street: string;
    city: string;
    country: string;
    zipCode: number | string;
    houseNumber: number | string;
  },
  t?: Function
) => {
  const { street, city, country, zipCode, houseNumber } = address || {};

  return `${street ? `${street},` : ''} ${houseNumber ? `${houseNumber},` : ''} ${
    zipCode ? `${zipCode},` : ''
  } ${city ? `${city},` : ''} 
  ${country ? `${t ? t(`common:country.${country}`) : country}` : ''}`;
};

export const formatTimeZone = (timezone: number) => {
  const resultTimezone: RawTimeZone | undefined = rawTimeZones.find(
    ({ rawOffsetInMinutes }: RawTimeZone) => rawOffsetInMinutes === timezone
  );

  return resultTimezone ? resultTimezone.rawFormat : '-';
};

export const getTimezoneValue = ({
  timezoneFullFormat,
  timezone,
}: {
  timezoneFullFormat?: string;
  timezone?: number;
}) => {
  if (timezoneFullFormat) {
    return timezoneFullFormat;
  }
  if (timezone) {
    return formatTimeZone(timezone);
  }
  return '';
};

export const filterOption = (value: string, option: any) => {
  if (typeof option.children === 'string') {
    return option.children.toLowerCase().includes(value.toLowerCase());
  }

  return option.children[1].toLowerCase().includes(value.toLowerCase());
};

export const getFiltersCount = (filters?: any) => {
  if (!filters) return '';

  const filtersCount = Object.values(filters).reduce(
    (acc: number, filter: any) => acc + filter.length,
    0
  );

  return filtersCount ? `(${filtersCount})` : '';
};

export const removeNullAndUndefined = <T extends Record<string, any>>(obj: T): T => {
  return Object.keys(obj).reduce((acc, key) => {
    const typedKey = key as keyof T;
    if (obj[typedKey] !== null && obj[typedKey] !== undefined) {
      acc[typedKey] = obj[typedKey];
    }
    return acc;
  }, {} as T);
};

export const generateReactKey = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

export const removeFileExtension = (filename: string): string => {
  return filename.replace(/\.[^/.]+$/, '');
};

export const generateStepArray = (start: number, end: number, step: number): string[] => {
  const result: string[] = [];
  for (let i = start; i <= end; i += step) {
    result.push(parseFloat(i.toFixed(1)).toString());
  }
  return result;
};

export const currencyFormatter = (value: number) =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
